export default __webpack_public_path__ + "static/allency_banner-2-53db7a32675405ce35422520126efbd8.png";